<template>
  <div class="container">
    <!-- 背景区域 -->
    <img class="collect-bg" src="@/assets/annualReport/collect-bg.png" alt="" />

    <div class="collect-btn">
      <img
        class="btn-img"
        src="@/assets/annualReport/home-button.gif"
        alt=""
        @click="handleClaimReport"
      />
      <div class="message-box" @click.stop>
        <div class="source-text">数据来源：库迪咖啡小程序/APP</div>
        <div class="agreement-box">
          <img
            v-if="!agreedToProtocol"
            src="@/assets/annualReport/no-check.png"
            @click="toggleCheck"
          />
          <img
            v-else
            src="@/assets/annualReport/check.png"
            @click="toggleCheck"
          />
          <span>我同意 </span>
          <agreement />
        </div>
      </div>
      <div class="bottom-message">
        本报告的视觉设计画面由<br />
        AI工具辅助生成，仅供参考与娱乐
      </div>
    </div>

    <van-popup
      v-model="popupVisible"
      position="bottom"
      round
      :get-container="getContainer"
    >
      <div class="popup-content">
        <div class="popup-tit">
          点击同意领取报告
          <img
            src="@/assets/annualReport/close_black.svg"
            class="u-icon-close"
            @click="popupVisible = false"
          />
          <!-- <van-icon name="cross" @click="popupVisible = false" /> -->
        </div>
        <div class="popup-text">
          <agreement :bottomBarHeight="bottomBarHeight"/>
        </div>
        <div class="popup-btn" :style="{marginBottom:(bottomBarHeight+40)+'px'}" @click="confirmAgreement">同意并继续</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { isCottiApp } from "@/utils/index.js";
import agreement from "../components/agreement.vue";
import { getWeChatScheme } from "@/api";

export default {
  name: "ReportClaimPage",
  components: {
    agreement,
  },
  props: {
    // 是否显示当前页
    active: {
      type: Boolean,
      default: false,
    },
    bottomBarHeight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      popupVisible: false,
      // 音乐相关
      isMuted: true,
      audioContext: null,

      // 协议相关
      agreedToProtocol: false,
      showTooltip: false,
      tooltipShaking: false,

      // 弹层控制
      showRulesModal: false,
      showProtocolModal: false,

      // 用户状态
      isLoggedIn: false,
      userInfo: null,

      // 其他状态
      isClaiming: false,

      agree: null,
      agreeFlag: true,
      popupVisible: false,
      isWaiting: false,
      mmm:''
    };
  },

  mounted() {
    // 初始化页面
    // this.initPage();
    // console.log(navigator.userAgent.split("/"),'-navigator.userAgent.split("/")');
    this.mmm = this.$route.query.mmm || '';
    if(this.mmm){
      let config = localStorage.getItem("annualReport_agreedToProtocol");
      if(config){
        this.agreedToProtocol = JSON.parse(config)[this.mmm] || false
      }
    }else{
      this.agreedToProtocol = false
    }
    
  },

  methods: {
    /**
     * 初始化页面
     */
    initPage() {},
    getContainer() {
      return document.body;
    },
    isAgree() {
      if (this.agreeFlag) {
        this.agree = "";
      }
      this.agreeFlag = true;
    },

    changeAgree() {
      this.agreeFlag = false;
    },
    toggleCheck() {
      this.agreedToProtocol = !this.agreedToProtocol;
      localStorage.setItem(
        "annualReport_agreedToProtocol",
        JSON.stringify({[this.mmm]:this.agreedToProtocol})
      );
    },
    confirmAgreement() {
      this.agreedToProtocol = true;
      localStorage.setItem(
        "annualReport_agreedToProtocol",
        JSON.stringify({[this.mmm]:this.agreedToProtocol})
      );
      this.popupVisible = false;
      this.handleClaimReport();
    },
    handleClaimReport() {
      if (isCottiApp()) {
        this.$sensors.track('annual_report_get_click',{
          agreedToProtocol: this.agreedToProtocol
        })
        // 检查是否同意协议
        if (!this.agreedToProtocol) {
          this.triggerVibration();
          this.popupVisible = true;
          return;
        }
        // 检查登录状态
        const token = sessionStorage.getItem("COTTI_USER_TOKEN");

        if (!token) {
          try {
            const data = "";
            NavigationLogin.postMessage(data);
            return;
          } catch (e) {
            console.warn("NavigationLogin is error");
            console.warn(e);
          }
        }

        this.$emit("next");
      } else {
        let appletUrl = "/packages/activity/annualReport/annualReport?auth=1";
        // let appletUrl = "pages/index/index";
        this.openApplet(appletUrl);
        // location.href = 'weixin://dl/business/?appid=*wxe766d738ad655e8c*&path=*/pages/index/index*&env_version=*trial*';
      }
    },
    openApplet(appletUrl) {
      this.isWaiting = true;
      try {
        const path = appletUrl.split("?")[0];
        const query = appletUrl.split("?")[1] || "";
        getWeChatScheme({ path, query }).then((res) => {
          console.log(res);

          if (res.data.scheme) {
            location.href = res.data.scheme;
            this.isWaiting = false;
          } else {
            this.$toast({ message: "打开小程序失败，请确认已安装微信" });
            this.isWaiting = false;
          }
        });
      } catch (e) {
        this.$toast({ message: "打开小程序失败，请确认已安装微信" });
        this.isWaiting = false;
      }
    },
    triggerVibration() {
      // 使用 APP Bridge 震动
      if (isCottiApp()) {
        try {
          hapticFeedback.postMessage("");
        } catch (e) {
          console.warn("APP震动调用失败", e);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100vh;
  width: 100%;
  .collect-bg {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .collect-btn {
    position: absolute;
    bottom: 45px;

    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .btn-img {
      width: 419px;
      // height: 144px;
      margin-bottom: -8px;
    }
    .message-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 400;
    font-size: 24px;
      color: #292424;
      text-align: center;
      line-height: 1.5;
      .source-text {
      }
      .agreement-box {
        display: flex;
        align-items: center;
        > img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          padding: 10px;
          margin: -10px 0 -10px -10px;
          cursor: pointer;
        }
      }
    }
  }
  .bottom-message {
    margin-top: 54px;
    font-weight: 400;
    font-size: 15px;
    color: #292424;
    line-height: 22px;
    text-align: center;
  }
}
.van-popup--bottom {
  border-radius: 16px 16px 0 0;

  .popup-content {
    width: 100%;
    height: 100%;

    .popup-tit {
      position: relative;
      text-align: center;
      line-height: 96px;
      height: 96px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #000000;
    }

    .u-icon-close {
      position: absolute;
      right: 20px;
      top: 25px;
      width: 48px;
      height: 48px;
    }

    .popup-text {
      text-align: center;
      height: 40px;
      font-weight: 400;
      font-size: 28px;
      color: #000000;
      line-height: 40px;
      text-decoration-line: underline;
      margin-bottom: 48px;
    }

    .popup-btn {
      height: 80px;
      margin: 16px 32px 40px;
      background: #a52337;
      border-radius: 40px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
    }
  }
}
</style>
